import { XStateEvent } from 'common/models/xstate';
import { assign, interpret, Machine } from 'xstate';
import { VaultModalEvent } from './vaultModalEvent';
import { XStateUtils } from './xStateUtils';

enum VaultModalState {
  BASE_STATE = 'BASE_STATE',
}

type VaultModalSchema = {
  states: {
    [s in VaultModalState]: object;
  };
};

type EventOpenDepositModal = XStateEvent<VaultModalEvent.OPEN_DEPOSIT_MODAL>;
type EventCloseDepositModal = XStateEvent<VaultModalEvent.CLOSE_DEPOSIT_MODAL>;
type EventOpenWithdrawModal = XStateEvent<VaultModalEvent.OPEN_WITHDRAW_MODAL>;
type EventCloseWithdrawModal =
  XStateEvent<VaultModalEvent.CLOSE_WITHDRAW_MODAL>;

type VaultModalEvents =
  | EventOpenDepositModal
  | EventCloseDepositModal
  | EventOpenWithdrawModal
  | EventCloseWithdrawModal;

type VaultModalContext = {
  isDepositModalOpen: boolean;
  isWithdrawModalOpen: boolean;
};

export const initialVaultModalContext: VaultModalContext = {
  isDepositModalOpen: false,
  isWithdrawModalOpen: false,
};

// // TODO: This should be better typed, anywhere you reference this vaultModalState$ it doesn't actually contain the value

const vaultModalMachine = Machine<
  VaultModalContext,
  VaultModalSchema,
  VaultModalEvents
>({
  key: 'vaultModal',
  initial: VaultModalState.BASE_STATE,
  context: XStateUtils.shortStringify(initialVaultModalContext),
  states: {
    [VaultModalState.BASE_STATE]: {
      on: {
        [VaultModalEvent.OPEN_DEPOSIT_MODAL]: {
          target: VaultModalState.BASE_STATE,
          actions: assign({
            isDepositModalOpen: () => true,
          }),
        },
        [VaultModalEvent.CLOSE_DEPOSIT_MODAL]: {
          target: VaultModalState.BASE_STATE,
          actions: assign({
            isDepositModalOpen: () => false,
          }),
        },
        [VaultModalEvent.OPEN_WITHDRAW_MODAL]: {
          target: VaultModalState.BASE_STATE,
          actions: assign({
            isWithdrawModalOpen: () => true,
          }),
        },
        [VaultModalEvent.CLOSE_WITHDRAW_MODAL]: {
          target: VaultModalState.BASE_STATE,
          actions: assign({
            isWithdrawModalOpen: () => false,
          }),
        },
      },
    },
  },
});

// Likely I want to do a createMachine here where I pass in some custom name or id.
const vaultModalService = interpret(vaultModalMachine, {
  // devTools: process.env.NODE_ENV === 'development'
}).start();

vaultModalService.subscribe((s) => {
  if (process.env.NODE_ENV === 'development') {
    console.debug('[vaultModalService:debug]', s);
  }
});

export const addLiquidityModalService = interpret(vaultModalMachine, {
  // devTools: process.env.NODE_ENV === 'development'
}).start();

addLiquidityModalService.subscribe((s) => {
  if (process.env.NODE_ENV === 'development') {
    console.debug('[addLiquidityModalService:debug]', s);
  }
});

const addStakeLpModalService = interpret(vaultModalMachine, {
  // devTools: process.env.NODE_ENV === 'development'
}).start();

addStakeLpModalService.subscribe((s) => {
  if (process.env.NODE_ENV === 'development') {
    console.debug('[addStakeLpModalService:debug]', s);
  }
});
// export type VaultModalMachineContext = { value: any; context: VaultModalContext; };

// // // TODO: This should be better typed, anywhere you reference this vaultModalState$ it doesn't actually contain the value
// export type VaultModalMachineState = StateMachine<VaultModalContext, XStateSchema<VaultModalState>, VaultModalEvents, VaultModalMachineContext>;

// export const vaultModalState$: Observable<VaultModalMachineState> = from((vaultModalService as unknown) as Observable<VaultModalMachineState>);

// // export const vaultModalMachine = vaultModalState$;
